// extracted by mini-css-extract-plugin
module.exports = {"poster":"index_poster_21hzT","canvas":"index_canvas_KP56x","screenshot":"index_screenshot_1oHnP"};